import { listCountryCatalog, type CountryCatalogEntry } from '../../../../shared/catalogs/country-catalog';

export const countries = listCountryCatalog().map((entry: CountryCatalogEntry) => ({
  code: entry.code,
  label: entry.name,
  phone: entry.phone ?? '',
}));
